import Vue from 'vue'
import Store from 'store'

import ProductTileGrid from './ProductTileGrid.vue'

const el = '.nti-component--product-tile-grid'
const DOM = document.querySelector(el)

const render = function(){
    if(DOM){
        new Vue({
            store: Store,
            el,
            components:{
                ProductTileGrid
            },
            template: '<ProductTileGrid />'
        })
    }
}

export default {
    render
}